import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { Category } from "../../categories.types";
import { requestCreateSubCategory } from "./createSubCategory.request";

const useCreateSubCategory = (
  options?: MutationOptions<Category, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateSubCategory,
    ...options
  });
};

export default useCreateSubCategory;
